import {createSelector} from 'reselect';
import {AppState} from '../../../index';

export const isNewsFilterCollapsedSelector = () =>
  createSelector(
    (state: AppState) => state.runtime.news.isFilterCollapsed,
    (item) => item,
  );

export const isFilterModalVisibleSelector = () =>
  createSelector(
    (state: AppState) => state.runtime.news.isFilterModalVisible,
    (item) => item,
  );
